import { formatNumberWithSpaces } from 'pages/calculator/MediaPlanning/common/BudgetTable/utils/formatNumberWithSpaces';

const formatBudgetDifferenceLabel = (budgetDifference: number) => {
  if (budgetDifference > 0) {
    return (
      <>
        {` (+${formatNumberWithSpaces(Math.abs(budgetDifference).toFixed(0))}`}
        <span>PLN</span>)
      </>
    );
  }

  if (budgetDifference < 0) {
    return (
      <>
        {` (-${formatNumberWithSpaces(Math.abs(budgetDifference).toFixed(0))}`}
        <span>PLN</span>)
      </>
    );
  }

  return null;
};

export default formatBudgetDifferenceLabel;
